export default function NavMenu() {
  return <></>;
}
